import { useViewContext } from "@editor-providers";
import { MOBILE_BREAKPOINT } from "@library/constants";
import { type ReactNode, memo } from "react";
import { useWindowSize } from "usehooks-ts";
import { useInitSlider } from "../hooks";
import { useActive } from "../providers";
import type { TabTitleType, TabsPayload } from "../types";

export const SliderWrapper = memo(
  ({
    children,
    id,
    titles,
    settings,
  }: {
    children: ReactNode[];
    titles: TabTitleType[];
    settings: TabsPayload;
    id: string;
  }) => {
    "use no memo";
    const { view } = useViewContext();
    const isStaticView = view === "default";
    const { width } = useWindowSize();
    const isMobile = width <= MOBILE_BREAKPOINT;
    const { active, setActive } = useActive();

    useInitSlider({
      id,
      isMobile,
      settings,
      isStaticView,
      titles,
      setActive,
      activeTabId: active,
    });

    if (isMobile && isStaticView) {
      return (
        <div className={`swiper-container-${id}`}>
          <div className="swiper-wrapper">{children}</div>
        </div>
      );
    }

    return <>{children}</>;
  },
);
